/*
 * @Author: 郑君婵
 * @Date: 2020-08-28 11:39:14
 * @LastEditTime: 2022-12-01 16:17:48
 * @Description: http
 */
// todo refactor
import creatHttp from './creatHttp';
import env from '../../../env/index';

const smartHttp = creatHttp(env.SMART_WIRUNG_SERVER);
const otmsHttp = creatHttp(env.OTMS_WEB_PLUS_SERVER);

const bfsSsoHttp = creatHttp(env.BFS_SSO_SERVER);
const bfsUserWebHttp = creatHttp(env.BFS_USER_WEB_SERVER);
const sfHttp = creatHttp(env.SF_SERVER);
const bigDataHttp = creatHttp(env.BIG_DATA_SERVER);
const bigDataWhereHouseHttp = creatHttp(env.BIG_DATA_SERVER_WHEREHOUSE);
const wmsHttp = creatHttp(env.WMS_WEB_PLUS_SERVER);
const bmsHttp = creatHttp(env.BMS_WEB_PLUS_SERVER);
const bmsWebHttp = creatHttp(env.BMS_WEB_SERVER);
const bmsUiHttp = creatHttp(env.BMS_UI);
const bmsBigData = creatHttp(env.BMS_BIGDATA);
const exportWeb = creatHttp(env.EXPORT_WEB);
// 老服务使用此 Http 服务
const noPrefixHttp = creatHttp('/');
const scHttp = creatHttp(env.SC_SERVER);
const dbisHttp = creatHttp(env.DBIS_SERVER);
const moonbox = creatHttp(env.MOONBOX)
export {
    otmsHttp,
    bfsSsoHttp,
    bfsUserWebHttp,
    noPrefixHttp,
    scHttp,
    sfHttp,
    bigDataHttp,
    dbisHttp,
    wmsHttp,
    bigDataWhereHouseHttp,
    bmsHttp,
    bmsWebHttp,
    bmsUiHttp,
    bmsBigData,
    exportWeb,
    smartHttp,
    moonbox
};
